<template>
	<div class="pdd">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onadd()">添加店铺</el-button>
		</div>
		
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.state" placeholder="状态">
							<el-option label="启用" :value="1"></el-option>
							<el-option label="禁用" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.shop_name" placeholder="拼多多"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			
			<div class="tablediv shop-table-wrap" ref="tablediv">
				<el-table :data="list" height="100%" size="small" class="shop-table">
					<el-table-column label="店铺图标" width="76" align="center" header-align="center">
						<template slot-scope="scope">
							<div class="shop-logo">
								<img v-if="scope.row.logo" :src="scope.row.logo" alt="">
								<i v-else class="el-icon-picture-outline"></i>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="拼多多店铺编号" min-width="140" align="center" header-align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							{{ scope.row.shop_id || '-' }}
						</template>
					</el-table-column>
					<el-table-column label="拼多多店铺名称" min-width="220" align="center" header-align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							<span class="shop-name">{{ scope.row.mall_name }}</span>
						</template>
					</el-table-column>
					<!-- <el-table-column label="渠道退货规则" align="center" header-align="center" min-width="110px">
						<template slot-scope="scope">
							<div v-for="(v,k) in appdata.list.pdd_return_rule" :key="k" v-if="scope.row.return_rule == v.id">{{v.name}}</div>
						</template>
					</el-table-column>
					<el-table-column label="撕防伪规则" align="center" header-align="center" min-width="100px">
						<template slot-scope="scope">
							<div v-for="(v,k) in appdata.list.pdd_security_rule" :key="k" v-if="scope.row.security_rule == v.id">{{v.name}}</div>
						</template>
					</el-table-column>
					<el-table-column label="发货时间规则" align="center" header-align="center" min-width="110px">
						<template slot-scope="scope">
							<div v-for="(v,k) in appdata.list.pdd_send_time_rule" :key="k" v-if="scope.row.send_time_rule == v.id">{{v.name}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="profit" label="利润比例" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="allocation_rate" label="配货率" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="on_time_rate" label="准时率" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="delivery_price" label="运费" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="show_max_num" label="显示最大数量" align="center" header-align="center" width="110px">
					</el-table-column> -->
					<el-table-column label="状态" width="128" align="center" header-align="center">
						<template slot-scope="scope">
							<div class="status-cell" :class="scope.row.state === 1 ? 'is-on' : 'is-off'">
								<el-switch
									v-model="scope.row.state"
									:active-value="1"
									:inactive-value="2"
									active-color="#ff4714"
									inactive-color="#dcdfe6"
									@change="onswitch(scope.row)"
								/>
								<span class="status-label">{{ scope.row.state === 1 ? '启用' : '禁用' }}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="授权过期时间" min-width="180" align="center" header-align="center">
						<template slot-scope="scope">
							<div class="expire-cell">
								<div
									class="expire-time"
									:class="{ 'is-expired': isAuthExpired(scope.row) }"
								>{{ formatDate(scope.row.expire_time) }}</div>
								<div class="expire-actions">
									<span v-if="isAuthExpired(scope.row)" class="expire-tip">已过期</span>
									<span class="cell-link" @click="onadd()">重新授权</span>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="120" align="center" header-align="center">
						<template slot-scope="scope">
							<span class="cell-link" @click="onsave(scope.row)">店铺配置</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>
		
		<el-dialog title="店铺配置" :visible.sync="show" width="650px" :before-close="onclose">
			<div class="forms" v-if="show">
				<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="130px">
					<el-form-item label="渠道退货规则" prop="return_rule" class="item">
						<el-select v-model="ruleForm.return_rule" placeholder="请选择渠道退货规则">
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.pdd_return_rule" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="撕防伪规则" prop="security_rule" class="item">
						<el-select v-model="ruleForm.security_rule" placeholder="请选择撕防伪规则">
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.pdd_security_rule" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="发货时间规则" prop="send_time_rule" class="item">
						<el-select v-model="ruleForm.send_time_rule" placeholder="请选择发货时间规则">
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.pdd_send_time_rule" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="利润比例" prop="profit" class="item">
						<el-input-number v-model="ruleForm.profit" :controls="false" :max="100">
						</el-input-number>
					</el-form-item>
					
					<el-form-item label="配货率" prop="allocation_rate" class="item">
						<el-input-number v-model="ruleForm.allocation_rate" :controls="false" :max="100">
						</el-input-number>
					</el-form-item>
					
					<el-form-item label="准时率" prop="on_time_rate" class="item">
						<el-input-number v-model="ruleForm.on_time_rate" :controls="false" :max="100">
						</el-input-number>
					</el-form-item>
					
					<el-form-item label="运费" prop="delivery_price" class="item">
						<el-input-number v-model="ruleForm.delivery_price" :precision="2" :controls="false">
						</el-input-number>
					</el-form-item>
					
					<el-form-item label="显示最大数量" prop="show_max_num" class="item">
						<el-input-number v-model="ruleForm.show_max_num" :controls="false">
						</el-input-number>
					</el-form-item>
					
					<el-form-item label="状态" prop="state" class="item">
						<el-switch v-model="ruleForm.state" :active-value="1" :inactive-value="2"></el-switch>
					</el-form-item>
				</el-form>
			</div>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose">取消</el-button>
				<el-button type="primary" @click="onsub()">确定</el-button>
			</div>
			
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'BasicConfig',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				show: false,
				checkobj: {},
				formfilter: {
					state: 1,
					shop_name: ""
				},
				ruleForm: {
					id: "",
					state: "",
					return_rule: "",
					security_rule: "",
					send_time_rule: "",
					profit: "",
					allocation_rate: "",
					on_time_rate: "",
					delivery_price: "",
					show_max_num: "",
				},
				rules: {
					return_rule: [{
						required: true,
						message: '请选择渠道退货规则',
						trigger: 'change'
					}],
					
					security_rule: [{
						required: true,
						message: '请选择撕防伪规则',
						trigger: 'change'
					}],
					
					send_time_rule: [{
						required: true,
						message: '请选择发货时间规则',
						trigger: 'change'
					}],
					
					profit: [{
						required: true,
						message: '请输入利润比例',
						trigger: 'blur'
					}],
					
					allocation_rate: [{
						required: true,
						message: '请输入配货率',
						trigger: 'blur'
					}],
					
					on_time_rate: [{
						required: true,
						message: '请输入准时率',
						trigger: 'blur'
					}],
					
					delivery_price: [{
						required: true,
						message: '请输入运费',
						trigger: 'blur'
					}],
					
					show_max_num: [{
						required: true,
						message: '请输入显示最大数量',
						trigger: 'blur'
					}],
				}
			}
		},
		
		inject: ['appdata'],
		
		mounted() {
			this.onlist();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},
		
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},
		
		methods: {
			onfilter() {
				this.page = 1;
				this.onlist();
			},
			
			onreset() {
				this.formfilter = {
					state: 1,
					shop_name: ""
				};
				this.page = 1;
				this.onlist();
			},
			
			handleCurrentChange() {
				this.onlist();
			},
					
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},
			onadd() {
				this.$axios.get('api/user/pdd_auth_url').then(res => {
					if (res.data.code == 0) {
						window.open(res.data.data.url, '_blank');
						// this.onlist();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onlist() {
				var obj = {};
				obj.state = this.formfilter.state;
				obj.shop_name = this.formfilter.shop_name;
				obj.page = this.page;
				obj.limit = this.pageSize;
					
				this.$axios.post('api/retail_shop/list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onsave(obj) {
				if (!obj || !obj.id) {
					this.$message.warning('店铺信息不完整')
					return
				}
				sessionStorage.setItem('retailShopId', String(obj.id))
				this.$router.push({
					path: '/StoreConfig/tabsConfig',
					query: { id: obj.id },
				})
			},
			
			onclose() {
				this.checkobj = {};
				this.show = false;
				this.ruleForm = {
					id: "",
					state: "",
					return_rule: "",
					security_rule: "",
					send_time_rule: "",
					profit: "",
					allocation_rate: "",
					on_time_rate: "",
					delivery_price: "",
					show_max_num: "",
				};
			},
			
			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm));
						// obj.id = this.checkobj.id;
						// console.log(obj);
						// return;
						this.$axios.post('api/user/pdd_shop_save', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose();
								this.onlist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},
			
			onswitch(data) {
				var obj = {
					id: data.id,
					state: data.state,
				};
				
				this.$axios.post('api/retail_shop/state_toggle', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('操作成功');
						this.onclose();
						this.onlist();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
            parseExpireTimestamp(expireTime) {
                if (expireTime == null || expireTime === '') {
                    return null
                }
                if (typeof expireTime === 'number' || /^\d+$/.test(String(expireTime))) {
                    var timestamp = Number(expireTime)
                    if (String(timestamp).length === 10) {
                        timestamp = timestamp * 1000
                    }
                    return timestamp
                }
                var parsed = this.$moment(expireTime)
                return parsed.isValid() ? parsed.valueOf() : null
            },
            isAuthExpired(row) {
                var timestamp = this.parseExpireTimestamp(row && row.expire_time)
                if (timestamp == null) {
                    return false
                }
                return timestamp < Date.now()
            },
            formatDate(expireTime) {
                var timestamp = this.parseExpireTimestamp(expireTime)
                if (timestamp == null) {
                    return '-'
                }
                return this.$moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
            }
		}
	}
</script>

<style scoped lang="less">
	.pdd {
		height: 100%;
        padding: 10px 10px 0 0;
        background-color: #fff;
	}
	
	.tablebox {
		height: calc(100% - 104px);
		padding: 0 4px;
	}

	.shop-table-wrap {
		height: 100%;
		background: #fff;
		border: 1px solid #ebeef5;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0 2px 12px rgba(15, 23, 42, 0.04);
	}

	.shop-table {
		font-size: 13px;
		color: #303133;
		background: transparent;

		&::before {
			height: 0;
		}

		/deep/ &::after {
			height: 1px;
			background-color: #ebeef5;
		}

		/deep/ thead {
			font-weight: normal;
		}

		/deep/ th.el-table__cell {
			background: #fafbfc;
			font-size: 13px;
			font-weight: normal;
			color: #606266;
			padding: 12px 0;
			border-right: none;
			border-bottom: 1px solid #ebeef5;

			.cell {
				font-size: 13px;
				font-weight: normal;
				line-height: 1.5;
			}
		}

		/deep/ td.el-table__cell {
			font-size: 13px;
			padding: 12px 0;
			border-right: none;
			border-bottom: 1px solid #ebeef5;

			.cell {
				font-size: 13px;
				line-height: 1.5;
			}
		}

		/deep/ tr:hover > td.el-table__cell {
			background: #fafbfc !important;
		}

		/deep/ .el-table__empty-text {
			font-size: 13px;
			color: #909399;
		}

		/deep/ .el-table__body-wrapper,
		/deep/ .el-table__header-wrapper {
			width: 100% !important;
		}
	}

	.shop-name {
		color: #303133;
	}

	.shop-logo {
		width: 52px;
		height: 52px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 8px;
		background: #f5f6f8;
		overflow: hidden;

		img {
			max-width: 100%;
			max-height: 100%;
			object-fit: contain;
		}

		i {
			font-size: 22px;
			color: #c0c4cc;
		}
	}

	.expire-cell {
		display: inline-flex;
		flex-direction: column;
		align-items: center;
		gap: 4px;
	}

	.expire-time {
		color: #606266;
		font-size: 13px;
		line-height: 1.4;

		&.is-expired {
			color: #f56c6c;
		}
	}

	.expire-tip {
		color: #409eff;
		font-size: 12px;
		line-height: 1.3;
	}

	.expire-actions {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
	}

	.cell-link {
		font-size: 13px;
		color: #ff4714;
		cursor: pointer;
		transition: opacity 0.2s;

		&:hover {
			opacity: 0.75;
		}
	}

	.status-cell {
		display: inline-flex;
		align-items: center;
		gap: 8px;
		padding: 4px 12px 4px 8px;
		border-radius: 20px;
		transition: background 0.2s;

		/deep/ .el-switch {
			height: 20px;
			line-height: 20px;

			.el-switch__core {
				width: 36px !important;
				height: 20px;
				border-radius: 10px;

				&::after {
					width: 16px;
					height: 16px;
				}
			}

			&.is-checked .el-switch__core::after {
				margin-left: -17px;
			}
		}

		.status-label {
			font-size: 13px;
			line-height: 1;
			white-space: nowrap;
		}

		&.is-on {
			background: rgba(255, 71, 20, 0.1);

			.status-label {
				color: #ff4714;
			}
		}

		&.is-off {
			background: #f5f6f8;

			.status-label {
				color: #909399;
			}
		}
	}
	
	/deep/ .el-input-number .el-input__inner {
		text-align: left;
	}
	
	/deep/ .item .el-select {
		width: 300px;
	}
	
	/deep/ .item .el-input-number {
		width: 300px;
	}
	
	/deep/ .item .el-textarea {
		width: 300px;
	}
</style>


// WEBPACK FOOTER //
// src/components/StoreConfig/basicConfig.vue